export default __webpack_public_path__ + "static/media/2416.b76cd414.png";